/**
 * Numeri scritti per i riquadri piccoli della dashboard: senza centesimi,
 * perche' in un quadratino "164.182 €" si legge e "164.182,29 €" no.
 * Le pagine complete restano con i centesimi (exportUtils.formatCurrency).
 */

const EURO_INTERO = new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 });
const INTERO = new Intl.NumberFormat('it-IT', { maximumFractionDigits: 0 });

export const euroIntero = (n: number): string => EURO_INTERO.format(Math.round(n));

export const numeroIntero = (n: number): string => INTERO.format(n);

/** "+12%" / "-5%" */
export const percentualeConSegno = (n: number): string => `${n > 0 ? '+' : ''}${n}%`;
